export default "__VITE_ASSET__5337dabe__"